export const mockInternetBar = {
  upgradeButtonLabel: 'Upgrade',
  enableWebSDK: 'true',
  welcomeTitle: 'Connected to the Internet',
  conservativeBonusPointsDesc:
    'Join for free and access complimentary Wi-Fi. Plus, earn 500 points for enrolling today.',
  signInButtonLink: '/sign-in.mi?layeredEncoding=true&returnTo=_PPV5URL_',
  loyaltyConnectNowButton: 'Connect Now',
  loyaltyJoinnowScenarioText: 'Not a Marriott Bonvoy® Member?',
  memberUpgradedDescription:
    'Welcome back! Please <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">sign in</a> to your Marriott Bonvoy™ account so that we can apply your member benefits.',
  loyaltyConnectScenarioText: 'Already a Marriott Bonvoy® Member?',
  trackingProperties: {
    additionalTrackingVariables: '',
    enableScrollingBehavior: false,
    trackingDescription: '',
    impressionTrack: false,
    trackingContentPosition: '',
    atCCeVar48: '',
    rightArrowDesc: '',
    leftArrowDesc: '',
    clickTrack: true,
    location: '',
    merchandisingCategory: 'nonCobrand',
    impressionCount: false,
    trackingOfferType: '',
    trackingTag: '',
  },
  wifiUpgradePmsFieldsBean: {
    errorMessagePms: "We can't connect you to the internet",
    descriptionPms: "Please try again. If you're still having trouble, contact the front desk",
    closingLabelPms: 'Close Dialog',
    headingtextPms: "We're Sorry",
  },
  wifiUpgradeSuccessNaFieldsBean: {
    descriptionSna: 'Please contact the front desk to see if an upgrade from your current plan is available.',
    upgradeMessageSna: 'Upgrade Not Available',
    closingLabelSna: 'Close Dialog',
    headingtextSna: "We're Sorry",
  },
  invalidCurrencyErrorFieldsBean: {
    errorMessageForIc: null,
    closingLabelForIc: null,
    headingForIc: null,
    descriptionForIc: null,
  },
  eliteMACDescription:
    "As an Elite Marriott Bonvoy™ member, you mean the world to us. You'll receive our fastest internet option at no charge.",
  uknownUpgradedDescription:
    'Marriott Bonvoy members who book direct receive a complimentary internet connection. <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">Sign in</a> or <a href="/loyalty/createAccount/createAccountPage1.mi" target="_blank">join now</a> - it\'s free!',
  accessCodeModel: {
    returnLabel: 'Return to Login',
    accessCodePlaceholder: null,
    requiredLabel: 'All fields are required',
    accessCodeLabel: 'ACCESS CODE',
    acErrorMessage: 'Invalid Access Code: Please Try Again',
    acTitle: 'Connect to the Internet',
    acClosingLabel: 'Close',
    acSeparatorLabel: 'OR',
    accessCodeTitle: 'Please Enter Your Access Code',
    continueButtonLabel: 'Continue',
  },
  joinAndConnectButton: 'Join and Connect',
  ':type': 'mi-aem-ppv5-spa/components/content/internet-box',
  loginModel: {
    loyaltyLoginDescriptionPublicZone: 'Connect now to the internet.',
    loyaltyConnectAsGuestCta: 'Connect as Guest',
    loginButtonLabel: 'Submit',
    title: 'Connect to the Internet',
    loyaltyLoginWelcomeText: 'Welcome to Marriott Bonvoy®',
    loyaltyLoginThankYouText: 'Thank you for being Marriott Bonvoy® Member.',
    loyaltyGuestAtHotelDescription: 'For guests at the hotel, please enter your information below.',
    loyaltyLoginDescription: "We'll email your Marriott Bonvoy® membership details.",
    closingLabel: 'Close Dialog',
    guestLoginLabel: 'Please Enter Your Information Below',
    lastNamePlaceHolder: 'Enter Last Name',
    separatorLabel: 'OR',
    loyaltyContinueAsMemberCta: 'Continue as a Member',
    roomNumberPlaceHolder: 'Enter Room Number',
    requestAccessCodeLabel: 'Request Access Code via SMS',
    loyaltyConnectAsMemberCta: 'Connect as Member',
    errorMessage: 'Room Number/Last Name Not Found:  Please Try Again',
    loyaltyLoginConnectNowButton: 'Connect Now',
    connectNowLabel: 'Connect for Free',
    lastNameLabel: 'LAST NAME',
    userAccessCodeLabel: 'Use an Access Code ',
    roomNumberLabel: 'ROOM NUMBER',
    loginUpgradeText: 'Connect to Enhanced Internet',
    requiredLabel: 'All fields are required',
    loginContinueButtonLabel: 'Continue',
  },
  upgradeButtonLinkInNewTab: '_self',
  signInButtonLabel: 'Sign In',
  memberNSDescription:
    'Welcome back! Please <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">sign in</a> to your Marriott Bonvoy™ account so that we can apply your member benefits.',
  isMBVMemberDesc: 'Members get free Wi-Fi.',
  currencyUxlFailureErrorFieldsBean: {
    errorMessageForCuf: null,
    closingLabelForCuf: null,
    descriptionForCuf: null,
    headingForCuf: null,
  },
  weChatFieldsBean: {
    weChatNotInstalledButton: 'No',
    weChatInstalled: 'Is WeChat Installed?',
    weChatConnectLabel: 'Connected to the Internet',
    weChatHeading: 'Join Marriott Bonvoy®',
    weChatInstalledButton: 'Yes',
    weChatDescription: 'Complete your Marriott Bonvoy® membership enrollment through WeChat',
  },
  memberInStayDescription:
    'Welcome back! Please <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">sign in</a> to your Marriott Bonvoy™ account so that we can apply your member benefits.',
  internetPricingModel: {
    connectNowLabel2: 'Connect Now',
    internetPricingClosingLabel: 'Close Dialog',
    choosedurationlabel: 'Choose Duration',
    pricelabel1: 'Price',
    resortDescription: 'Free for Marriott Bonvoy Members. Included with Resort Fee.',
    pricelabel2: 'Price',
    description2:
      'Free for Marriott Bonvoy Gold and Higher Status Members. Best for: Streaming, Video Conferencing and On-line video games',
    pricingInfo: {
      GuestRoom: {
        tierTwoFee: '19.95',
        tierOneFee: '16.95',
        tierOneName: 'Tier 1 (basic)',
        tierTwoName: 'Tier 2',
        tierTwoId: 5552808,
        tierOneId: 5480578,
        hasTierTwo: true,
        hasTierOne: true,
      },
      PublicArea: {
        tierTwoId: 0,
        tierOneId: 0,
        hasTierTwo: false,
        hasTierOne: true,
      },
    },
    intUpgResortDescription:
      'Added to your current connection plan.  Enhanced Internet is included with the Resort Fee and is always free for Marriott Bonvoy Gold and higher Elite Members.',
    durationlabel2: 'Choose Duration',
    destinationDescription2: 'Free for Marriott Bonvoy Gold and Higher Status Members. Included with Destination Fee.',
    intUpgConnectLabel: 'Upgrade your Connection',
    intUpgDestinationDescription:
      'Added to your current connection plan.  Enhanced Internet is included with the Destination Fee and is always free for Marriott Bonvoy Gold and higher Elite Members.',
    currency: 'USD',
    intUpgDurationLabel: 'CHOOSE DURATION',
    resortDescriptionPP: 'Free for Marriott Bonvoy Members. Best for: Web browsing and Email',
    intUpgClosingLabel: 'Close',
    internetPricingConnectNowLabel: 'Connect Now',
    destinationDescriptionPP: 'Free for Marriott Bonvoy Members. Best for: Web browsing and Email',
    intUpgFreeLabel: 'Free',
    intUpgNoThanksLink: 'No thanks, Keep my current connection.',
    description2label: 'Description',
    intUpgTierTitle: 'Enhanced Internet',
    freeDescription: 'Connect to free internet',
    resortDescription2: 'Free for Marriott Bonvoy Gold and Higher Status Members. Included with Resort Fee.',
    intUpgDescription:
      'Added to your current connection plan.  Marriott Bonvoy Members receive free internet as a benefit. Gold and higher Elite Members receive free Enhanced Internet service as an Elite benefit.',
    title2: 'Enhanced Internet',
    dayLabel: '/day',
    intUpgConnectionLabel: 'Upgrade Connection',
    justDaysLabel: 'Days',
    internetPricingDescription: 'Free for Marriott Bonvoy Members. Best for: Web browsing and Email',
    justDayLabel: 'Day',
    internetPricingTitle: 'Internet',
    destinationDescription: 'Free for Marriott Bonvoy Members. Included with Destination Fee.',
    description1label: 'Description',
    connectlabelTier1: 'Connect  to the Internet',
    freeLabel: 'Free',
  },
  calaProperty: false,
  wifiUpgradeLrFieldsBean: {
    headingtextLr: "We're Sorry",
    errorMessageLr: "We can't connect you to the internet",
    closingLabelLr: 'Close Dialog',
    descriptionLr: "Please try again. If you're still having trouble, contact the front desk",
  },
  basicInStayMACDescription: 'Welcome back! And thank you for being a Marriott Bonvoy™ member.',
  joinButtonLinkInNewTab: '_blank',
  joinMBVMemberLabel: 'Join for free and access complimentary Wi-Fi.',
  notMBVMemberDesc:
    'Membership is free. Join now and access complimentary Wi-Fi today and on all of your future stays.',
  upgradeTitle: 'Upgrade Your Connection',
  eliteInStayMACDescription: 'Welcome back! And thank you for being an Elite Marriott Bonvoy™ member.',
  tier1Title: 'Connected to the Internet',
  unknownConnectedDescription:
    'Marriott Bonvoy members who book direct receive a complimentary internet connection. <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">Sign in</a> or <a href="/loyalty/createAccount/createAccountPage1.mi" target="_blank">join now</a> - it\'s free!',
  connectButtonLabel: 'Connect',
  eliteMACUgradedDescription: 'Welcome back! And thank you for being an Elite Marriott Bonvoy™ member.',
  memberTierUnknownDescription: '<p>Thank you for being a Marriott Bonvoy™ member.</p>\r\n',
  conservativeWithIncentiveTnC:
    'By joining and connecting, you accept the <a href="http://www.marriott.com/marriott/internet-access/termsofuse.mi" target="_blank">Internet Terms</a> and the <a data-custom_click_track_value="Offer Terms and Conditions">Offer Terms and Conditions</a>',
  loyaltyConnectScenarioDescription: 'Enjoy your complimentary Wi-Fi benefit, and thank you for your loyalty.',
  basicUpgradeDescription: '<p>Welcome back! And thank you for being a Marriott Bonvoy™ member.</p>\r\n',
  eliteUpgradedDescription: 'Welcome back! And thank you for being an Elite Marriott Bonvoy™ member.',
  unknownDescription:
    'Marriott Bonvoy members who book direct receive a complimentary internet connection. <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">Sign in</a> or <a href="/loyalty/createAccount/createAccountPage1.mi" target="_blank">Join now</a> - it\'s free!',
  eliteDescription:
    "As an Elite Marriott Bonvoy™ member, you mean the world to us. You'll receive our fastest internet option at no charge.",
  eliteInStayDescription: 'Welcome back! And thank you for being an Elite Marriott Bonvoy™ member.',
  internetSignInText:
    '<a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">Sign in</a> to unlock exclusive benefits and make the most of your Marriott experience.',
  offersTnCDescription:
    '<p>(i) Bonus Points will be awarded to the member’s Account within 72 hours after enrollment is complete.</p>\r\n<p>(ii)This promotion is valid only for new members of the Marriott Bonvoy® program.Existing Marriott Bonvoy members are not eligible for this promotion. Any newly enrolled Accounts for existing members may be merged into the existing Account and are not eligible for this promotion.</p>\r\n<p>(iii) All Marriott Bonvoy loyalty program terms and conditions apply. See <a href="https://www.marriott.com/loyalty/terms/default.mi" target="_blank">https://www.marriott.com/loyalty/terms/default.mi</a> for more information.</p>\r\n',
  isMBVMemberNoLabel: 'No',
  basicDescription:
    "<p>Welcome back! As a valued Marriott Bonvoy™ member, you'll receive a complimentary internet connection.</p>\r\n",
  signInButtonLinkInNewTab: '_blank',
  enableCNWeChat: false,
  deviceTitle: 'Device Added to Your Internet Plan',
  isMBVMemberYesLabel: 'Yes',
  marketingBonusPointsDesc: 'Plus, earn 500 bonus points towards free nights just for joining today.',
  title: 'Connect to the Internet',
  requestAccessCodeModel: {
    frequentCountry: [],
    racSeparatorLabel: 'OR',
    searchCountryRegionLabel: 'Search Country/Region',
    racTitle: 'Connect to the Internet',
    racContinueButtonLabel: 'Continue',
    phoneNumberPlaceholder: null,
    defaultOption: 'Select Country/Region Code',
    racReturnLabel: 'Return to Login',
    enterYourPhoneNumber: 'ENTER YOUR PHONE NUMBER',
    requestAccessCodeModelLabel: 'Request Access Code via SMS',
    racClosingLabel: 'Close',
    guidLinks: [
      {
        guidAltDecode: 'AF',
        guidDecode: 'Afghanistan',
        guidCode: '93',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AX',
        guidDecode: 'Aland Islands',
        guidCode: '358',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AL',
        guidDecode: 'Albania',
        guidCode: '355',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'DZ',
        guidDecode: 'Algeria',
        guidCode: '213',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AD',
        guidDecode: 'Andorra',
        guidCode: '376',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AO',
        guidDecode: 'Angola',
        guidCode: '244',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AI',
        guidDecode: 'Anguilla',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AQ',
        guidDecode: 'Antarctica',
        guidCode: '672',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AG',
        guidDecode: 'Antigua',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AR',
        guidDecode: 'Argentina',
        guidCode: '54',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AM',
        guidDecode: 'Armenia',
        guidCode: '374',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AW',
        guidDecode: 'Aruba',
        guidCode: '297',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AU',
        guidDecode: 'Australia',
        guidCode: '61',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AT',
        guidDecode: 'Austria',
        guidCode: '43',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AZ',
        guidDecode: 'Azerbaijan',
        guidCode: '994',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BS',
        guidDecode: 'Bahamas',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BH',
        guidDecode: 'Bahrain',
        guidCode: '973',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BD',
        guidDecode: 'Bangladesh',
        guidCode: '880',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BB',
        guidDecode: 'Barbados',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BY',
        guidDecode: 'Belarus',
        guidCode: '375',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BE',
        guidDecode: 'Belgium',
        guidCode: '32',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BZ',
        guidDecode: 'Belize',
        guidCode: '501',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BJ',
        guidDecode: 'Benin',
        guidCode: '229',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BM',
        guidDecode: 'Bermuda',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BT',
        guidDecode: 'Bhutan',
        guidCode: '975',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BO',
        guidDecode: 'Bolivia',
        guidCode: '591',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BQ',
        guidDecode: 'Bonaire',
        guidCode: '599',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BA',
        guidDecode: 'Bosnia Hercegovina',
        guidCode: '387',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BW',
        guidDecode: 'Botswana',
        guidCode: '267',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BV',
        guidDecode: 'Bouvet Island',
        guidCode: '55',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IO',
        guidDecode: 'Br Indian Ocean Terr',
        guidCode: '246',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BR',
        guidDecode: 'Brazil',
        guidCode: '55',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'VG',
        guidDecode: 'British Virgin Islands',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BN',
        guidDecode: 'Brunei Darussalam',
        guidCode: '673',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BG',
        guidDecode: 'Bulgaria',
        guidCode: '359',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BF',
        guidDecode: 'Burkina Faso',
        guidCode: '226',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BI',
        guidDecode: 'Burundi',
        guidCode: '257',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CB',
        guidDecode: 'Cambodia',
        guidCode: '855',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CM',
        guidDecode: 'Cameroon',
        guidCode: '237',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CA',
        guidDecode: 'Canada',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CV',
        guidDecode: 'Cape Verde',
        guidCode: '238',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KY',
        guidDecode: 'Cayman Islands',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CF',
        guidDecode: 'Cent Africa Republic',
        guidCode: '236',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TD',
        guidDecode: 'Chad',
        guidCode: '235',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CL',
        guidDecode: 'Chile',
        guidCode: '56',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CN',
        guidDecode: 'China',
        guidCode: '86',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CX',
        guidDecode: 'Christmas Island',
        guidCode: '61',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CC',
        guidDecode: 'Cocos Islands',
        guidCode: '891',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CO',
        guidDecode: 'Colombia',
        guidCode: '57',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KM',
        guidDecode: 'Comoro Islands',
        guidCode: '269',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CG',
        guidDecode: 'Congo',
        guidCode: '242',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CD',
        guidDecode: 'Congo, Dem. Republic',
        guidCode: '243',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CK',
        guidDecode: 'Cook Islands',
        guidCode: '682',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CR',
        guidDecode: 'Costa Rica',
        guidCode: '506',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'HR',
        guidDecode: 'Croatia',
        guidCode: '385',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CU',
        guidDecode: 'Cuba',
        guidCode: '53',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CW',
        guidDecode: 'Curacao',
        guidCode: '599',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CY',
        guidDecode: 'Cyprus',
        guidCode: '357',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CZ',
        guidDecode: 'Czech Republic',
        guidCode: '420',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'DK',
        guidDecode: 'Denmark',
        guidCode: '45',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'DJ',
        guidDecode: 'Djibouti',
        guidCode: '253',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'DM',
        guidDecode: 'Dominica',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'DO',
        guidDecode: 'Dominican Republic',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'EC',
        guidDecode: 'Ecuador',
        guidCode: '593',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'EG',
        guidDecode: 'Egypt',
        guidCode: '20',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SV',
        guidDecode: 'El Salvador',
        guidCode: '503',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GQ',
        guidDecode: 'Equatorial Guinea',
        guidCode: '240',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ER',
        guidDecode: 'Eritrea',
        guidCode: '291',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'EE',
        guidDecode: 'Estonia',
        guidCode: '372',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ET',
        guidDecode: 'Ethiopia',
        guidCode: '251',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'FO',
        guidDecode: 'Faeroe Islands',
        guidCode: '298',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'FK',
        guidDecode: 'Falkland Islands',
        guidCode: '500',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'FJ',
        guidDecode: 'Fiji',
        guidCode: '679',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'FI',
        guidDecode: 'Finland',
        guidCode: '358',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'FR',
        guidDecode: 'France',
        guidCode: '33',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GF',
        guidDecode: 'French Guiana',
        guidCode: '594',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PF',
        guidDecode: 'French Polynesia',
        guidCode: '689',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TF',
        guidDecode: 'French Southern Terr',
        guidCode: '262',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GA',
        guidDecode: 'Gabon',
        guidCode: '241',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GM',
        guidDecode: 'Gambia',
        guidCode: '220',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'XA',
        guidDecode: 'Gaza',
        guidCode: '970',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GE',
        guidDecode: 'Georgia',
        guidCode: '995',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'DE',
        guidDecode: 'Germany',
        guidCode: '49',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GH',
        guidDecode: 'Ghana',
        guidCode: '233',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GI',
        guidDecode: 'Gibraltar',
        guidCode: '350',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GR',
        guidDecode: 'Greece',
        guidCode: '30',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GL',
        guidDecode: 'Greenland',
        guidCode: '299',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GD',
        guidDecode: 'Grenada',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GP',
        guidDecode: 'Guadeloupe',
        guidCode: '33',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GT',
        guidDecode: 'Guatemala',
        guidCode: '502',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GG',
        guidDecode: 'Guernsey',
        guidCode: '44',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GN',
        guidDecode: 'Guinea',
        guidCode: '224',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GW',
        guidDecode: 'Guinea-Bissau',
        guidCode: '245',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GY',
        guidDecode: 'Guyana',
        guidCode: '592',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'HT',
        guidDecode: 'Haiti',
        guidCode: '509',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'HM',
        guidDecode: 'Heard & McDonald Island',
        guidCode: '+0',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'HN',
        guidDecode: 'Honduras',
        guidCode: '504',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'HK',
        guidDecode: 'Hong Kong',
        guidCode: '852',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'HU',
        guidDecode: 'Hungary',
        guidCode: '36',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IS',
        guidDecode: 'Iceland',
        guidCode: '354',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IN',
        guidDecode: 'India',
        guidCode: '91',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'XI',
        guidDecode: 'Indian Ocean Islands',
        guidCode: '61',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ID',
        guidDecode: 'Indonesia',
        guidCode: '62',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IR',
        guidDecode: 'Iran',
        guidCode: '98',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IQ',
        guidDecode: 'Iraq',
        guidCode: '964',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IE',
        guidDecode: 'Ireland',
        guidCode: '353',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IM',
        guidDecode: 'Isle of Man',
        guidCode: '44',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IL',
        guidDecode: 'Israel',
        guidCode: '972',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'IT',
        guidDecode: 'Italy',
        guidCode: '39',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CI',
        guidDecode: 'Ivory Coast',
        guidCode: '225',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'JM',
        guidDecode: 'Jamaica',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'JP',
        guidDecode: 'Japan',
        guidCode: '81',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'JE',
        guidDecode: 'Jersey',
        guidCode: '44',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'JO',
        guidDecode: 'Jordan',
        guidCode: '962',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KZ',
        guidDecode: 'Kazakhstan',
        guidCode: '7',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KE',
        guidDecode: 'Kenya',
        guidCode: '254',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KI',
        guidDecode: 'Kiribati',
        guidCode: '686',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KP',
        guidDecode: 'Korea, Dem. Peoples',
        guidCode: '850',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KR',
        guidDecode: 'Korea, Republic of',
        guidCode: '82',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CS',
        guidDecode: 'Kosovo',
        guidCode: '383',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KW',
        guidDecode: 'Kuwait',
        guidCode: '965',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KG',
        guidDecode: 'Kyrgyzstan',
        guidCode: '996',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LP',
        guidDecode: 'Lao P D R',
        guidCode: '856',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LA',
        guidDecode: 'Laos',
        guidCode: '856',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LV',
        guidDecode: 'Latvia',
        guidCode: '371',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LB',
        guidDecode: 'Lebanon',
        guidCode: '961',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LW',
        guidDecode: 'Leeward Islands',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LS',
        guidDecode: 'Lesotho',
        guidCode: '266',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LR',
        guidDecode: 'Liberia',
        guidCode: '231',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LY',
        guidDecode: 'Libya',
        guidCode: '218',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LI',
        guidDecode: 'Liechtenstein',
        guidCode: '423',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LT',
        guidDecode: 'Lithuania',
        guidCode: '370',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LU',
        guidDecode: 'Luxembourg',
        guidCode: '352',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MO',
        guidDecode: 'Macau',
        guidCode: '853',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MK',
        guidDecode: 'Macedonia',
        guidCode: '389',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MG',
        guidDecode: 'Madagascar',
        guidCode: '261',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MW',
        guidDecode: 'Malawi',
        guidCode: '265',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MY',
        guidDecode: 'Malaysia',
        guidCode: '60',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MV',
        guidDecode: 'Maldives',
        guidCode: '960',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ML',
        guidDecode: 'Mali',
        guidCode: '223',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MT',
        guidDecode: 'Malta',
        guidCode: '356',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MQ',
        guidDecode: 'Martinique',
        guidCode: '596',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MR',
        guidDecode: 'Mauritania',
        guidCode: '222',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MU',
        guidDecode: 'Mauritius',
        guidCode: '230',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'YT',
        guidDecode: 'Mayotte',
        guidCode: '33',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MX',
        guidDecode: 'Mexico',
        guidCode: '52',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MD',
        guidDecode: 'Moldova, Republic of',
        guidCode: '373',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MC',
        guidDecode: 'Monaco',
        guidCode: '377',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MN',
        guidDecode: 'Mongolia',
        guidCode: '976',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ME',
        guidDecode: 'Montenegro',
        guidCode: '382',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MS',
        guidDecode: 'Montserrat',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MA',
        guidDecode: 'Morocco',
        guidCode: '212',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MZ',
        guidDecode: 'Mozambique',
        guidCode: '258',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MM',
        guidDecode: 'Myanmar',
        guidCode: '95',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NA',
        guidDecode: 'Namibia',
        guidCode: '264',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NR',
        guidDecode: 'Nauru',
        guidCode: '674',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NP',
        guidDecode: 'Nepal',
        guidCode: '977',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AN',
        guidDecode: 'Netherland Antilles',
        guidCode: '599',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NL',
        guidDecode: 'Netherlands',
        guidCode: '31',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NC',
        guidDecode: 'New Caledonia',
        guidCode: '687',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NZ',
        guidDecode: 'New Zealand',
        guidCode: '64',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NI',
        guidDecode: 'Nicaragua',
        guidCode: '505',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NE',
        guidDecode: 'Niger',
        guidCode: '227',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NG',
        guidDecode: 'Nigeria',
        guidCode: '234',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NU',
        guidDecode: 'Niue',
        guidCode: '683',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NF',
        guidDecode: 'Norfolk Island',
        guidCode: '672',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'NO',
        guidDecode: 'Norway',
        guidCode: '47',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'OM',
        guidDecode: 'Oman',
        guidCode: '968',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PK',
        guidDecode: 'Pakistan',
        guidCode: '92',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PA',
        guidDecode: 'Panama',
        guidCode: '507',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PG',
        guidDecode: 'Papua New Guinea',
        guidCode: '675',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PY',
        guidDecode: 'Paraguay',
        guidCode: '595',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PE',
        guidDecode: 'Peru',
        guidCode: '51',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PH',
        guidDecode: 'Philippines',
        guidCode: '63',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PN',
        guidDecode: 'Pitcairn Island',
        guidCode: '64',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PL',
        guidDecode: 'Poland',
        guidCode: '48',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PT',
        guidDecode: 'Portugal',
        guidCode: '351',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'QA',
        guidDecode: 'Qatar',
        guidCode: '974',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'RE',
        guidDecode: 'Reunion',
        guidCode: '262',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'RO',
        guidDecode: 'Romania',
        guidCode: '40',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'RU',
        guidDecode: 'Russia',
        guidCode: '7',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'RW',
        guidDecode: 'Rwanda',
        guidCode: '250',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GS',
        guidDecode: 'S Georgia-S Sandwich',
        guidCode: '500',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'BL',
        guidDecode: 'Saint Barthelemy',
        guidCode: '590',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LC',
        guidDecode: 'Saint Lucia',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'MF',
        guidDecode: 'Saint Martin',
        guidCode: '590',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'WS',
        guidDecode: 'Samoa, Ind. State of',
        guidCode: '685',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SM',
        guidDecode: 'San Marino',
        guidCode: '378',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ST',
        guidDecode: 'Sao Tome-Principe',
        guidCode: '239',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SA',
        guidDecode: 'Saudi Arabia',
        guidCode: '966',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SN',
        guidDecode: 'Senegal',
        guidCode: '221',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'RS',
        guidDecode: 'Serbia',
        guidCode: '381',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SC',
        guidDecode: 'Seychelles',
        guidCode: '248',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SL',
        guidDecode: 'Sierra Leone',
        guidCode: '232',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SG',
        guidDecode: 'Singapore',
        guidCode: '65',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SK',
        guidDecode: 'Slovakia',
        guidCode: '421',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SI',
        guidDecode: 'Slovenia',
        guidCode: '386',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SB',
        guidDecode: 'Solomon Islands',
        guidCode: '677',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SO',
        guidDecode: 'Somalia',
        guidCode: '252',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ZA',
        guidDecode: 'South Africa',
        guidCode: '27',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SS',
        guidDecode: 'South Sudan',
        guidCode: '211',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ES',
        guidDecode: 'Spain',
        guidCode: '34',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'LK',
        guidDecode: 'Sri Lanka',
        guidCode: '94',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SH',
        guidDecode: 'St Helena',
        guidCode: '247',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'KN',
        guidDecode: 'St Kitts-Nevis',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SX',
        guidDecode: 'St Maarten',
        guidCode: '599',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PM',
        guidDecode: 'St Pierre & Miquelon',
        guidCode: '508',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'VC',
        guidDecode: 'St Vincent & The Gre',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SD',
        guidDecode: 'Sudan',
        guidCode: '249',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SR',
        guidDecode: 'Suriname',
        guidCode: '597',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SJ',
        guidDecode: 'Svalbard & Jan Mayen',
        guidCode: '47',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SZ',
        guidDecode: 'Swaziland',
        guidCode: '268',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SE',
        guidDecode: 'Sweden',
        guidCode: '46',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'CH',
        guidDecode: 'Switzerland ',
        guidCode: '41',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'SY',
        guidDecode: 'Syrian Arab Republic',
        guidCode: '963',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TW',
        guidDecode: 'Taiwan',
        guidCode: '886',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TJ',
        guidDecode: 'Tajikstan',
        guidCode: '992',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TZ',
        guidDecode: 'Tanzania',
        guidCode: '255',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TH',
        guidDecode: 'Thailand',
        guidCode: '66',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TL',
        guidDecode: 'Timor-Leste',
        guidCode: '670',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TG',
        guidDecode: 'Togo',
        guidCode: '228',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TK',
        guidDecode: 'Tokelau',
        guidCode: '690',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TO',
        guidDecode: 'Tonga',
        guidCode: '676',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TT',
        guidDecode: 'Trinidad & Tobago',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TN',
        guidDecode: 'Tunisia',
        guidCode: '216',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TR',
        guidDecode: 'Turkey',
        guidCode: '90',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TM',
        guidDecode: 'Turkmenistan',
        guidCode: '993',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TC',
        guidDecode: 'Turks & Caicos',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'TV',
        guidDecode: 'Tuvalu',
        guidCode: '688',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'US',
        guidDecode: 'USA',
        guidCode: '1',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'UG',
        guidDecode: 'Uganda',
        guidCode: '256',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'UA',
        guidDecode: 'Ukraine',
        guidCode: '380',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'AE',
        guidDecode: 'United Arab Emirates',
        guidCode: '971',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'GB',
        guidDecode: 'United Kingdom',
        guidCode: '44',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'UV',
        guidDecode: 'Upper Volta',
        guidCode: '226',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'UY',
        guidDecode: 'Uruguay',
        guidCode: '598',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'UZ',
        guidDecode: 'Uzbekistan',
        guidCode: '998',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'VU',
        guidDecode: 'Vanuatu',
        guidCode: '678',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'VA',
        guidDecode: 'Vatican City',
        guidCode: '379',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'VE',
        guidDecode: 'Venezuela',
        guidCode: '58',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'VN',
        guidDecode: 'Vietnam',
        guidCode: '84',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'WF',
        guidDecode: 'Wallis & Futuna',
        guidCode: '681',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'PS',
        guidDecode: 'West Bank',
        guidCode: '970',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'EH',
        guidDecode: 'Western Sahara',
        guidCode: '212',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'YE',
        guidDecode: 'Yemen, Republic of',
        guidCode: '967',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ZM',
        guidDecode: 'Zambia',
        guidCode: '260',
        'jcr:primaryType': 'nt:unstructured',
      },
      {
        guidAltDecode: 'ZW',
        guidDecode: 'Zimbabwe',
        guidCode: '263',
        'jcr:primaryType': 'nt:unstructured',
      },
    ],
    requiredLabel: 'All fields are required',
    countryCode: 'SELECT YOUR COUNTRY/REGION CODE',
    priorityCountries: [
      {
        guidAltDecode: 'CN',
        guidDecode: 'China',
        'jcr:mixinTypes': ['cq:LiveRelationship'],
        'cq:lastRolledout': 1692626009542,
        guidCode: '86',
        'jcr:primaryType': 'nt:unstructured',
        'cq:lastRolledoutBy': 'ogaut080',
      },
      {
        guidAltDecode: 'HK',
        guidDecode: 'Hong Kong',
        'jcr:mixinTypes': ['cq:LiveRelationship'],
        'cq:lastRolledout': 1692626009547,
        guidCode: '852',
        'jcr:primaryType': 'nt:unstructured',
        'cq:lastRolledoutBy': 'ogaut080',
      },
      {
        guidAltDecode: 'MO',
        guidDecode: 'Macau',
        'jcr:mixinTypes': ['cq:LiveRelationship'],
        'cq:lastRolledout': 1692626009545,
        guidCode: '853',
        'jcr:primaryType': 'nt:unstructured',
        'cq:lastRolledoutBy': 'ogaut080',
      },
      {
        guidAltDecode: 'TW',
        guidDecode: 'Taiwan',
        'jcr:mixinTypes': ['cq:LiveRelationship'],
        'cq:lastRolledout': 1692626009549,
        guidCode: '886',
        'jcr:primaryType': 'nt:unstructured',
        'cq:lastRolledoutBy': 'ogaut080',
      },
    ],
    racErrorMessage: 'Invalid Phone Number: Please Try Again',
  },
  dataLists: {
    lrParamList: 'AF_AC,AF_MO,STRICT_AS,STRICT_A,STRICT_N,TCTC,STRICT_S,AF_AO,STRICT_AO',
    mSParamList: 'E,N',
    debounce: '5000',
    mVParamList: 'LOGIN,LOGERR,C_PRICE,REQSMS,REQSMSERR,ACCESS,ACCESSERR,U_PRICE,U_NA,U_MAX,U_CONF,INT_ERR',
    zoneValues: {
      CONFERENCE: 'SF',
      GUEST: 'PP',
      PUBLIC: 'SF',
    },
    zParamList: 'PUBLIC,GUEST,MEETING,LOBBY,CONFERENCE',
    enrollmentSourceCode: 'MRPI',
    sourceSystem: 'property-portal',
    segmentId: 'elite.nonrewards',
    loyaltyEnrollmentSourceCode: 'WFS8',
    calaLoyaltyEnrollmentSourceCode: 'WFC5',
  },
  termsAndConditions:
    'By connecting, you accept our <a href="http://www.marriott.com/marriott/internet-access/termsofuse.mi" target="_blank">Terms of Use</a>',
  basicInStayDescription: 'Welcome back! And thank you for being a Marriott Bonvoy™ member.',
  signInText:
    'Already a member? <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">Sign in</a>',
  wifiUpgradeMaxFieldsBean: {
    errorMessageMax: "We can't connect you to the internet",
    descriptionMax: "Please try again. If you're still having trouble, contact the front desk",
    closingLabelMax: 'Close Dialog',
    headingtextMax: "We're Sorry",
  },
  joinButtonLabel: 'Join Now',
  eliteTier1Description:
    '<p>Your internet connection is complimentary, in recognition of your Marriott Bonvoy™ membership.</p>\r\n',
  newAgeExp: 'Let us help you connect to Wi-Fi.',
  conferenceZoneBasicDescription:
    'Welcome back! And thank you for being a Marriott Bonvoy™ member. Browse our services below and explore all you can enjoy during your time with us.',
  loyaltyJoinnowScenarioDescription: 'Join for free to access complimentary Wi-Fi.',
  eliteTier2Description:
    '<p>Your Enhanced Internet connection is complimentary, in recognition of your Elite Marriott Bonvoy™ membership.</p>\r\n',
  wifiUpgradeSuccessMaxFieldsBean: {
    upgradeMessageSmax: "You're Already Connected at our Highest Speed",
    closingLabelSmax: 'Close Dialog',
    headingtextSmax: "We're Sorry",
    descriptionSmax: 'Your device is already connected at our highest-level internet option.',
  },
  conferenceZoneEliteDescription:
    'Welcome back! And thank you for being an Elite Marriott Bonvoy™ member. Browse our services below and explore all you can enjoy during your time with us.',
  sourceSystemCode: true,
  isMBVMemberLabel: 'First, are you a Marriott Bonvoy® Member?',
  joinButtonLink: '/loyalty/createAccount/createAccountPage1.mi',
  uknownInStayDescription:
    'Marriott Bonvoy members who book direct receive a complimentary internet connection. <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">Sign in</a> or <a href="/loyalty/createAccount/createAccountPage1.mi" target="_blank">join now</a> - it\'s free! ',
  eliteMACUgradeDescription: 'Welcome back! And thank you for being an Elite Marriott Bonvoy™ member.',
  basicMACUpgradeDescription: '<p>Welcome back! And thank you for being a Marriott Bonvoy™ member.</p>\r\n',
  eliteUpgradeDescription: 'Welcome back! And thank you for being an Elite Marriott Bonvoy™ member.',
  welcomeText:
    'Your stay starts here. Browse our services below and explore all you can enjoy during your time with us.',
  wifiUpgradeCreditFieldsBean: {
    headingtext1: "We're Sorry",
    upgradeMessage: "We can't complete your request",
    closingLabel1: 'Close Dialog',
    description1:
      'We do not have a valid credit card on file to enable your internet access. Please contact the front desk to make payment arrangements.',
  },
  basicMACUpgradedDescription: '<p>Welcome back! And thank you for being a Marriott Bonvoy™ member.</p>\r\n',
  basicMACDescription:
    "<p>Welcome back! As a valued Marriott Bonvoy™ member, you'll receive a complimentary internet connection.</p>\r\n",
  uknownUpgradeDescription:
    'Marriott Bonvoy members who book direct receive a complimentary internet connection. <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">Sign in</a> or <a href="/loyalty/createAccount/createAccountPage1.mi" target="_blank">join now</a> - it\'s free!',
  upgradedTitle: 'Connection Upgraded',
  basicUpgradedDescription: '<p>Welcome back! And thank you for being a Marriott Bonvoy™ member.</p>\r\n',
  tier2Title: 'Connected to Enhanced Internet',
  wifiUpgradeErrorFieldsBean: {
    upgradeErrorMessage: "We can't connect you to the internet",
    headingtext: "We're Sorry",
    upgradeErrorClosingLabel: 'Close Dialog',
    upgradeErrorDescription: "Please try again. If you're still having trouble, contact the front desk",
  },
  marketingOffersTnC:
    'By joining, you accept the <a data-custom_click_track_value="Offer Terms and Conditions.">Offer Terms and Conditions.</a>',
  upgradeButtonLink: 'https://internetupgrade.marriott.com/',
  memberMACDescription: '<p>Thank you for being a Marriott Bonvoy™ member.</p>\r\n',
  conferenceZoneUnknownDescription:
    '<a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">Sign in</a> to your Marriott Bonvoy® account or <a href="/loyalty/createAccount/createAccountPage1.mi" target="_blank">Join now</a> to access our exclusive services and discover everything you can enjoy during your stay with us.',
  memberUpgradeDescription:
    'Welcome back! Please <a href="/sign-in.mi?layeredEncoding=true&amp;returnTo=_PPV5URL_" target="_blank">sign in</a> to your Marriott Bonvoy™ account so that we can apply your member benefits.',
  basicTier1Description:
    '<p>Your internet connection is complimentary, in recognition of your Marriott Bonvoy™ membership.</p>\r\n',
};

export const mockPageParamContext = {
  preProcessorResponse: {
    userSegment: 'NOT Logged In',
    validMarsha: true,
    status: 'SUCCESS',
    message: '',
    statusCode: '200',
    brandCode: 'MC',
    experienceSegment: 'Connected-Unknown-Tier1-Guest',
    locale: 'en-US',
    subDirectory: 'en',
    currentStateMapping: {
      title: 'tier1Title',
      welcomeText: 'welcomeText',
      description: 'unknownConnectedDescription',
      isConnectState: false,
      connectUpgradeBtn: 'upgradeButtonLabel',
      signInButton: {
        signInButtonLink: '',
        signInButtonLabel: '',
        signInButtonLinkInNewTab: '',
      },
      joinNowButton: {
        joinButtonLabel: 'joinButtonLabel',
        joinButtonLink: 'joinButtonLink',
        joinButtonLinkInNewTab: 'joinButtonLinkInNewTab',
      },
      termsAndConditions: 'termsAndConditions',
      signInText: '',
      noLoginInterfaceModal: false,
      showLoginModal: true,
      loginModal: {
        default: true,
        separatorLabel: false,
        userAccessCodeLabel: false,
        requestAccessCodeLabel: false,
        errorMessage: false,
        connectNowLabel: false,
      },
      showAccessModal: false,
      accessModal: {
        default: false,
        acErrorMessage: false,
      },
      showReqAccessModal: false,
      reqAccessModal: {
        default: false,
        racErrorMessage: false,
      },
      showUpgradeGenErr: false,
      showUpgradeLRErr: false,
      showUpgradeMaxErr: false,
      showUpgradeNoCCErr: false,
      showUpgradePMSErr: false,
      showUpgradeSuccessNAInfo: false,
      showUpgradeSuccessMAXInfo: false,
      showPricingModal: false,
      showUpgradeModal: false,
      showLoyaltyWelcomeModal: false,
    },
    enrollmentSourceCodeMapping: {
      nonloyalty: [],
      loyalty: [
        {
          globalDivision: ['US Canada'],
          countryCode: [],
          pricingTier: [
            {
              value: 'WFS8',
              key: '*',
            },
            {
              value: 'WFP1',
              key: 'PP',
            },
          ],
        },
        {
          globalDivision: ['Caribbean Latin America'],
          countryCode: [],
          pricingTier: [
            {
              value: 'WFC5',
              key: '*',
            },
          ],
        },
        {
          globalDivision: ['EMEA'],
          countryCode: [],
          pricingTier: [
            {
              value: 'WFE4',
              key: '*',
            },
          ],
        },
        {
          globalDivision: ['Asia Pacific'],
          countryCode: [],
          pricingTier: [
            {
              value: 'WFS8',
              key: '*',
            },
          ],
        },
      ],
    },
    weChatEnrollmentSourceCodes: null,
    appId: 'mi-aem-ppv5-spa',
    enableLoyalty: false,
    enableLoyaltyPostConnect: false,
    disableImageModifier: false,
    ageExperienceConfig: null,
    pageComponentOrder: {
      itemsOrder: [
        'staticwrapper_672883066',
        'localheader',
        'hero_banner',
        'brandedcontainer_1172064606',
        'brandedcontainer_1917356031',
        'brandedcontainer_1528490355',
        'brandedcontainer_403518150',
        'brandedcontainer_1436165928',
        'brandedcontainer_449247067',
        'brandedcontainer_391718765',
        'brandedcontainer_940818128',
        'brandedcontainer_897514845',
        'brandedcontainer',
        'brandedcontainer_7866',
        'brandedcontainer_884195529',
        'brandedcontainer_1698652066',
        'language_selector',
      ],
    },
    propertyInfo: {
      data: {
        __typename: 'Hotel',
        basicInformation: {
          __typename: 'HotelBasicInformation',
          brand: {
            __typename: 'Brand',
            id: 'MC',
          },
          currency: 'USD',
          globalDivision: 'US Canada',
        },
        contactInformation: {
          __typename: 'PropertyContactInformation',
          address: {
            __typename: 'PropertyAddress',
            country: {
              __typename: 'Lookup',
              code: 'US',
            },
          },
        },
        internet: {
          __typename: 'PropertyInternetDetails',
          connectionPricingDetails: [
            {
              __typename: 'PropertyInternetConnectionPricingDetail',
              externalRecordId: 5445772,
              feeDetails: {
                __typename: 'FeeDetails',
                fee: null,
                feeInterval: null,
                feeType: 'C',
                settlementCurrency: null,
                settlementFee: null,
              },
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier1',
              type: 'public_area_room_conn_pricing',
            },
            {
              __typename: 'PropertyInternetConnectionPricingDetail',
              externalRecordId: 5552808,
              feeDetails: {
                __typename: 'FeeDetails',
                fee: 19.95,
                feeInterval: 'PD',
                feeType: 'F',
                settlementCurrency: null,
                settlementFee: null,
              },
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier2',
              type: 'guest_room_conn_pricing',
            },
            {
              __typename: 'PropertyInternetConnectionPricingDetail',
              externalRecordId: 5480578,
              feeDetails: {
                __typename: 'FeeDetails',
                fee: 16.95,
                feeInterval: 'PD',
                feeType: 'F',
                settlementCurrency: null,
                settlementFee: null,
              },
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier1',
              type: 'guest_room_conn_pricing',
            },
          ],
        },
      },
    },
    loyaltyFlip: false,
    mac: false,
    cna: false,
    sameTab: true,
    marsha: 'NYCEX',
    state: 'connected',
    userState: 'unknown',
    cookie: 'sessionID=834C5053-1717-5780-998E-E2FD5EECA1BA',
    headersData: {},
  },
};

export const inStayMockResponse = {
  title: 'welcomeTitle',
  welcomeText: 'welcomeText',
  description: 'uknownInStayDescription',
  isConnectState: false,
  connectUpgradeBtn: '',
  signInButton: {
    signInButtonLink: '',
    signInButtonLabel: '',
    signInButtonLinkInNewTab: '',
  },
  joinNowButton: {
    joinButtonLabel: 'joinButtonLabel',
    joinButtonLink: 'joinButtonLink',
    joinButtonLinkInNewTab: 'joinButtonLinkInNewTab',
  },
  termsAndConditions: '',
  signInText: '',
  noLoginInterfaceModal: true,
  showLoginModal: false,
  loginModal: {
    default: false,
    separatorLabel: false,
    userAccessCodeLabel: false,
    requestAccessCodeLabel: false,
    errorMessage: false,
    connectNowLabel: false,
  },
  showAccessModal: false,
  accessModal: {
    default: false,
    acErrorMessage: false,
  },
  showReqAccessModal: false,
  reqAccessModal: {
    default: false,
    racErrorMessage: false,
  },
  showUpgradeGenErr: false,
  showUpgradeLRErr: false,
  showUpgradeMaxErr: false,
  showUpgradeNoCCErr: false,
  showUpgradePMSErr: false,
  showUpgradeSuccessNAInfo: false,
  showUpgradeSuccessMAXInfo: false,
  showPricingModal: false,
  showUpgradeModal: false,
};

export const mockPageParamConnectNoLogin = {
  preProcessorResponse: {
    userSegment: 'NOT Logged In',
    validMarsha: true,
    status: 'SUCCESS',
    message: '',
    statusCode: '200',
    brandCode: 'MC',
    experienceSegment: 'PreConnect-Basic-Login',
    locale: 'en-US',
    subDirectory: 'en-US',
    currentStateMapping: {
      title: 'title',
      welcomeText: '',
      description: 'unknownDescription',
      isConnectState: true,
      connectUpgradeBtn: 'connectButtonLabel',
      signInButton: {
        signInButtonLink: '',
        signInButtonLabel: '',
        signInButtonLinkInNewTab: '',
      },
      joinNowButton: {
        joinButtonLabel: '',
        joinButtonLink: '',
        joinButtonLinkInNewTab: '',
      },
      termsAndConditions: 'termsAndConditions',
      signInText: 'signInText',
      noLoginInterfaceModal: false,
      showLoginModal: true,
      loginModal: {
        default: true,
      },
      showAccessModal: false,
      accessModal: {
        default: false,
        acErrorMessage: false,
      },
      showReqAccessModal: false,
      reqAccessModal: {
        default: false,
        racErrorMessage: false,
      },
      showUpgradeGenErr: false,
      showUpgradeLRErr: false,
      showUpgradeMaxErr: false,
      showUpgradeNoCCErr: false,
      showUpgradePMSErr: false,
      showUpgradeSuccessNAInfo: false,
      showUpgradeSuccessMAXInfo: false,
      showPricingModal: false,
      showUpgradeModal: false,
    },
    mac: false,
    cna: false,
    sameTab: true,
    marsha: 'nycmq',
    state: 'preconnect',
    userState: 'unknown',
    cookie: 'sessionID=3005DD4B-E88F-55E9-8121-11000350065E',
  },
};

export const mockPageParamUpgrade = {
  preProcessorResponse: {
    userSegment: 'NOT Logged In',
    validMarsha: true,
    status: 'SUCCESS',
    message: '',
    statusCode: '200',
    brandCode: 'JW',
    experienceSegment: 'Upgrade-Elite-UPrice-Guest',
    locale: 'en-US',
    subDirectory: 'en-US',
    currentStateMapping: {
      title: 'upgradeTitle',
      welcomeText: 'welcomeText',
      description: 'uknownUpgradeDescription',
      isConnectState: false,
      connectUpgradeBtn: 'upgradeButtonLabel',
      signInButton: {
        signInButtonLink: '',
        signInButtonLabel: '',
        signInButtonLinkInNewTab: '',
      },
      joinNowButton: {
        joinButtonLabel: 'joinButtonLabel',
        joinButtonLink: 'joinButtonLink',
        joinButtonLinkInNewTab: 'joinButtonLinkInNewTab',
      },
      termsAndConditions: 'termsAndConditions',
      signInText: '',
      noLoginInterfaceModal: false,
      showLoginModal: false,
      loginModal: {
        default: false,
        separatorLabel: false,
        userAccessCodeLabel: false,
        requestAccessCodeLabel: false,
        errorMessage: false,
        connectNowLabel: false,
      },
      showAccessModal: false,
      accessModal: {
        default: false,
        acErrorMessage: false,
      },
      showReqAccessModal: false,
      reqAccessModal: {
        default: false,
        racErrorMessage: false,
      },
      showUpgradeGenErr: false,
      showUpgradeLRErr: false,
      showUpgradeMaxErr: false,
      showUpgradeNoCCErr: false,
      showUpgradePMSErr: false,
      showUpgradeSuccessNAInfo: false,
      showUpgradeSuccessMAXInfo: false,
      showPricingModal: false,
      showUpgradeModal: true,
    },
    mac: false,
    cna: false,
    sameTab: false,
    marsha: 'phxdr',
    state: 'upgrade',
    userState: 'unknown',
    cookie: 'sessionID=39C7006B-7E45-5826-A938-137927E49324',
  },
};

export const settlementCurrenyDetailsMock = {
  data: {
    property: {
      basicInformation: {
        globalDivision: 'Caribbean Latin America',
        currency: 'USD',
        region: 'US East',
      },
      contactInformation: {
        address: {
          country: {
            code: 'CB',
          },
          stateProvince: {
            code: 'NY',
            description: 'New York',
            enumCode: null,
            label: null,
          },
        },
      },
      internet: {
        connectionPricingDetails: [
          {
            externalRecordId: 5443201,
            hasOtherThanHotelQuotingCurrency: true,
            isCompForBonvoyElite: null,
            isCompForBonvoyMember: null,
            tierType: 'Tier1',
            type: 'public_area_room_conn_pricing',
            feeDetails: {
              fee: 27,
              feeInterval: 'PD',
              feeType: 'F',
              settlementFee: 232,
              settlementCurrency: {
                description: 'Bermudian Dollar',
                code: 'BMD',
              },
            },
          },
          {
            externalRecordId: 299285,
            hasOtherThanHotelQuotingCurrency: true,
            isCompForBonvoyElite: null,
            isCompForBonvoyMember: null,
            tierType: 'Tier2',
            type: 'public_area_room_conn_pricing',
            feeDetails: {
              fee: 51,
              feeInterval: 'PD',
              feeType: 'F',
              settlementFee: 5000,
              settlementCurrency: {
                description: 'Bahamian Dollar',
                code: 'BSD',
              },
            },
          },
          {
            externalRecordId: 5439670,
            hasOtherThanHotelQuotingCurrency: true,
            isCompForBonvoyElite: false,
            isCompForBonvoyMember: true,
            tierType: 'Tier1',
            type: 'guest_room_conn_pricing',
            feeDetails: {
              fee: 15.7,
              feeInterval: 'PH',
              feeType: 'F',
              settlementFee: 150,
              settlementCurrency: {
                description: 'UAE Dirham',
                code: 'AED',
              },
            },
          },
          {
            externalRecordId: 299286,
            hasOtherThanHotelQuotingCurrency: false,
            isCompForBonvoyElite: true,
            isCompForBonvoyMember: false,
            tierType: 'Tier2',
            type: 'guest_room_conn_pricing',
            feeDetails: {
              fee: 22,
              feeInterval: 'PH',
              feeType: 'F',
              settlementFee: null,
              settlementCurrency: null,
            },
          },
        ],
      },
    },
  },
};

export const mockPageParam = {
  preProcessorResponse: {
    userSegment: 'NOT Logged In',
    validMarsha: true,
    status: 'SUCCESS',
    message: '',
    statusCode: '200',
    brandCode: 'RI',
    experienceSegment: 'PreConnect-Unknown-Internet-Plan-Public',
    locale: 'en-US',
    subDirectory: 'en',
    enrollmentSourceCodeMapping: `{"nonloyalty":[{"globalDivision":["US Canada"],"countryCode":["US"],"pricingTier":[{"value":"WFS8","key":"*"}]},{"globalDivision":["US Canada"],"countryCode":[],"pricingTier":[{"value":"WFS8","key":"*"}]},{"globalDivision":["Caribbean Latin America"],"countryCode":["CB"],"pricingTier":[{"value":"CALA_BS_CODE_FP","key":"FP"},{"value":"CALA_BS_CODE_SF","key":"SF"},{"value":"CALA_BS_CODE_SP","key":"SP"},{"value":"CALA-PP","key":"PP"}]},{"globalDivision":["Caribbean Latin America"],"countryCode":[],"pricingTier":[{"value":"WFC5","key":"*"}]},{"globalDivision":["Greater China"],"countryCode":["HK"],"pricingTier":[{"value":"WFS6","key":"*"}]}],"loyalty":[{"globalDivision":["US Canada"],"countryCode":["US"],"pricingTier":[{"value":"WFS8","key":"*"},{"value":"CALA_BS_CODE_FP","key":"FP"},{"value":"CALA_BS_CODE_SF","key":"SF"},{"value":"CALA_BS_CODE_SP","key":"SP"}]},{"globalDivision":["US Canada"],"countryCode":[],"pricingTier":[{"value":"WFS8","key":"*"}]},{"globalDivision":["Caribbean Latin America"],"countryCode":["CB"],"pricingTier":[{"value":"CALA_BS_CODE_FP","key":"FP"},{"value":"CALA_BS_CODE_SF","key":"SF"},{"value":"CALA_BS_CODE_SP","key":"SP"},{"value":"CALA-PP","key":"PP"}]},{"globalDivision":["Caribbean Latin America"],"countryCode":[],"pricingTier":[{"value":"WFC5","key":"*"}]},{"globalDivision":["Greater China"],"countryCode":["HK"],"pricingTier":[{"value":"WFS6","key":"*"}]}]}`,
    currentStateMapping: {
      title: 'title',
      welcomeText: '',
      description: 'unknownDescription',
      isConnectState: true,
      connectUpgradeBtn: 'connectButtonLabel',
      signInButton: {
        signInButtonLink: '',
        signInButtonLabel: '',
        signInButtonLinkInNewTab: '',
      },
      joinNowButton: {
        joinButtonLabel: '',
        joinButtonLink: '',
        joinButtonLinkInNewTab: '',
      },
      termsAndConditions: 'termsAndConditions',
      signInText: 'signInText',
      noLoginInterfaceModal: false,
      showLoginModal: true,
      loginModal: {
        default: true,
      },
      showAccessModal: false,
      accessModal: {
        default: false,
        acErrorMessage: false,
      },
      showReqAccessModal: false,
      reqAccessModal: {
        default: false,
        racErrorMessage: false,
      },
      showUpgradeGenErr: false,
      showUpgradeLRErr: false,
      showUpgradeMaxErr: false,
      showUpgradeNoCCErr: false,
      showUpgradePMSErr: false,
      showUpgradeSuccessNAInfo: false,
      showUpgradeSuccessMAXInfo: false,
      showPricingModal: true,
      showUpgradeModal: false,
      showLoyaltyWelcomeModal: false,
    },
    appId: 'mi-aem-ppv5-spa',
    disableImageModifier: false,
    enableLoyalty: true,
    mac: false,
    cna: false,
    sameTab: false,
    loyaltyFlip: false,
    marsha: 'MIANM',
    state: 'preconnect',
    userState: 'unknown',
    cookie: 'sessionID=D8349FDB-BC50-55BC-BBED-643153FAF2E1',
    headersData: {},
  },
};

export const mockPreprocessorMarketing = {
  preProcessorResponse: {
    ...mockPageParam.preProcessorResponse,
    enableLoyalty: true,
    enableLoyaltyPostConnect: false,
    ageExperienceConfig: {
      propertyType: 'Autograph-Tribute',
      enrollmentcode: 'WFQP',
      userExperience: 'marketing-with-incentive',
    },
    enableLoyaltyConference: false,
    enableLoyaltyConferencePostConnect: false,
    loyaltyForConferenceZone: false,
  },
};

export const mockPreProcessorResponseReqSMS = {
  preProcessorResponse: {
    userSegment: 'NOT Logged In',
    validMarsha: true,
    status: 'SUCCESS',
    message: '',
    statusCode: '200',
    brandCode: 'RI',
    experienceSegment: 'PreConnect-Unknown-Login-CodeLink-SMS',
    locale: 'en-US',
    subDirectory: 'en',
    currentStateMapping: {
      title: 'title',
      welcomeText: '',
      description: 'unknownDescription',
      isConnectState: true,
      connectUpgradeBtn: 'connectButtonLabel',
      signInButton: {
        signInButtonLink: '',
        signInButtonLabel: '',
        signInButtonLinkInNewTab: '',
      },
      joinNowButton: {
        joinButtonLabel: '',
        joinButtonLink: '',
        joinButtonLinkInNewTab: '',
      },
      termsAndConditions: 'termsAndConditions',
      signInText: 'signInText',
      noLoginInterfaceModal: false,
      showLoginModal: true,
      loginModal: {
        default: true,
        separatorLabel: true,
        userAccessCodeLabel: false,
        requestAccessCodeLabel: true,
      },
      showAccessModal: false,
      accessModal: {
        default: false,
        acErrorMessage: false,
      },
      showReqAccessModal: true,
      reqAccessModal: {
        default: true,
      },
      showUpgradeGenErr: false,
      showUpgradeLRErr: false,
      showUpgradeMaxErr: false,
      showUpgradeNoCCErr: false,
      showUpgradePMSErr: false,
      showUpgradeSuccessNAInfo: false,
      showUpgradeSuccessMAXInfo: false,
      showPricingModal: false,
      showUpgradeModal: false,
      showLoyaltyWelcomeModal: false,
    },
    enrollmentSourceCodeMapping: {
      nonloyalty: [],
      loyalty: [
        {
          globalDivision: ['US Canada'],
          enableSkipEnrollmentVerbiage: false,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFS8',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [
            {
              pricingTier: [
                {
                  value: 'WFDA',
                  key: '*',
                },
              ],
              brandTier: 'select',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDB',
                  key: '*',
                },
              ],
              brandTier: 'premium',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDC',
                  key: '*',
                },
              ],
              brandTier: 'luxury',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDA',
                  key: '*',
                },
              ],
              brandTier: 'longer stays',
              experience: 'conservative-without-incentive',
            },
          ],
        },
        {
          globalDivision: ['EMEA'],
          enableSkipEnrollmentVerbiage: false,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFE4',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: true,
          brandTierCategories: [
            {
              pricingTier: [
                {
                  value: 'WFDG',
                  key: '*',
                },
              ],
              brandTier: 'select',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDH',
                  key: '*',
                },
              ],
              brandTier: 'premium',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDI',
                  key: '*',
                },
              ],
              brandTier: 'luxury',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDG',
                  key: '*',
                },
              ],
              brandTier: 'longer stays',
              experience: 'conservative-without-incentive',
            },
          ],
        },
        {
          globalDivision: ['Caribbean Latin America'],
          enableSkipEnrollmentVerbiage: false,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFC5',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [
            {
              pricingTier: [
                {
                  value: 'WFDD',
                  key: '*',
                },
              ],
              brandTier: 'select',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDE',
                  key: '*',
                },
              ],
              brandTier: 'premium',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDF',
                  key: '*',
                },
              ],
              brandTier: 'luxury',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDD',
                  key: '*',
                },
              ],
              brandTier: 'longer stays',
              experience: 'conservative-without-incentive',
            },
          ],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFA1',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['AU'],
          pricingTier: [
            {
              value: 'WFAU',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['BD'],
          pricingTier: [
            {
              value: 'WFBD',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['BT'],
          pricingTier: [
            {
              value: 'WFBT',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['KH'],
          pricingTier: [
            {
              value: 'WFKH',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['FJ'],
          pricingTier: [
            {
              value: 'WFFJ',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['GU'],
          pricingTier: [
            {
              value: 'WFGU',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['IN'],
          pricingTier: [
            {
              value: 'WFIN',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['ID'],
          pricingTier: [
            {
              value: 'WF3D',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['JP'],
          pricingTier: [
            {
              value: 'WFJP',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['MY'],
          pricingTier: [
            {
              value: 'WFMY',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['MV'],
          pricingTier: [
            {
              value: 'WFMV',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['NP'],
          pricingTier: [
            {
              value: 'WFNP',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['NC'],
          pricingTier: [
            {
              value: 'WFNC',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['NZ'],
          pricingTier: [
            {
              value: 'WFNZ',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['PH'],
          pricingTier: [
            {
              value: 'WFPH',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['WS'],
          pricingTier: [
            {
              value: 'WFWS',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['SG'],
          pricingTier: [
            {
              value: 'WFSG',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['KR'],
          pricingTier: [
            {
              value: 'WFKR',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['LK'],
          pricingTier: [
            {
              value: 'WFLK',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['TH'],
          pricingTier: [
            {
              value: 'WFTH',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['VN'],
          pricingTier: [
            {
              value: 'WFVN',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Greater China'],
          enableSkipEnrollmentVerbiage: true,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFYN',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
        },
      ],
    },
    weChatEnrollmentSourceCodes: [
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWC',
            key: '*',
          },
        ],
        region: 'Mainland China',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWH',
            key: '*',
          },
        ],
        region: 'Hong Kong',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWM',
            key: '*',
          },
        ],
        region: 'Macau',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWT',
            key: '*',
          },
        ],
        region: 'Taiwan',
      },
    ],
    appId: 'mi-aem-ppv5-spa',
    enableLoyalty: true,
    enableLoyaltyPostConnect: false,
    disableImageModifier: false,
    ageExperienceConfig: null,
    pageComponentOrder: {
      itemsOrder: [
        'staticwrapper_672883066',
        'localheader',
        'hero_banner',
        'brandedcontainer_1172064606',
        'brandedcontainer_1917356031',
        'brandedcontainer_1528490355',
        'brandedcontainer_403518150',
        'brandedcontainer_1436165928',
        'brandedcontainer_1698652079',
        'brandedcontainer_449247067',
        'brandedcontainer_391718765',
        'brandedcontainer_940818128',
        'brandedcontainer_897514845',
        'brandedcontainer',
        'brandedcontainer_7866',
        'brandedcontainer_884195529',
        'brandedcontainer_1698652066',
        'language_selector',
      ],
    },
    propertyInfo: {
      data: {
        basicInformation: {
          globalDivision: 'US Canada',
          currency: 'USD',
          region: 'US East',
        },
        contactInformation: {
          address: {
            country: {
              code: 'US',
            },
          },
        },
        internet: {
          connectionPricingDetails: [
            {
              externalRecordId: 5931023,
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier1',
              type: 'public_area_room_conn_pricing',
              feeDetails: {
                fee: null,
                feeInterval: null,
                feeType: 'C',
                settlementFee: null,
                settlementCurrency: null,
              },
            },
            {
              externalRecordId: 5909298,
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier1',
              type: 'guest_room_conn_pricing',
              feeDetails: {
                fee: 0,
                feeInterval: null,
                feeType: 'C',
                settlementFee: null,
                settlementCurrency: null,
              },
            },
            {
              externalRecordId: 6057621,
              hasOtherThanHotelQuotingCurrency: true,
              tierType: 'Tier2',
              type: 'guest_room_conn_pricing',
              feeDetails: {
                fee: 4.95,
                feeInterval: 'PD',
                feeType: 'F',
                settlementFee: 7,
                settlementCurrency: {
                  description: 'Jordanian Dinar',
                  code: 'JOD',
                },
              },
            },
          ],
        },
      },
    },
    enableLoyaltyConference: false,
    enableLoyaltyConferencePostConnect: false,
    loyaltyFlip: false,
    sameTab: false,
    cna: false,
    mac: false,
    marsha: 'MIANM',
    acceptLanguage: 'en-US,en;q=0.9',
    state: 'preconnect',
    userState: 'unknown',
    cookie: 'sessionID=592D70E4-79E9-5814-8CA7-CC7B8F284295',
    headersData: {
      host: 'phoenix-www.swi-bpv.marriott.com',
      'x-request-id': '/einterface/v5/MIANM~X~C99E58F1-0188-52E7-9357-780BCA40C17C',
      'x-real-ip': '163.116.205.113',
      'x-forwarded-for': '163.116.205.113',
      'x-forwarded-host': 'phoenix-www.swi-bpv.marriott.com',
      'x-forwarded-port': '443',
      'x-forwarded-proto': 'https',
      'x-forwarded-scheme': 'https',
      'x-scheme': 'https',
      'x-original-forwarded-for': '163.116.205.113',
      'accept-language': 'en-US,en;q=0.9',
      pragma: 'no-cache',
      'sec-ch-ua': '"Not(A:Brand";v="8", "Chromium";v="144", "Google Chrome";v="144"',
      'sec-ch-ua-mobile': '?0',
      'sec-ch-ua-platform': '"Windows"',
      'upgrade-insecure-requests': '1',
      'user-agent':
        'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36',
      accept:
        'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
      'sec-fetch-site': 'same-origin',
      'sec-fetch-mode': 'navigate',
      'sec-fetch-user': '?1',
      'sec-fetch-dest': 'document',
      eks: 'true',
      priority: 'u=0, i',
      cookie:
        'device-characteristics=brand_name=Chrome&model_name=144&marketing_name=Chrome+144&device_os=Windows+NT&device_os_version=10.0&mobile_browser=Chrome&mobile_browser_version=144&is_mobile=false&is_tablet=false;OptanonConsent=isGpcEnabled=0&datestamp=Fri+Jan+30+2026+20%3A06%3A07+GMT%2B0530+(India+Standard+Time)&version=202411.2.0&browserGpcFlag=0&isIABGlobal=false&hosts=&consentId=ea338703-b880-4e69-8976-55340506687f&interactionCount=1&isAnonUser=1&landingPath=NotLandingPage&groups=1%3A1%2C3%3A1%2C4%3A1%2C6%3A1&AwaitingReconsent=false;authStateToken=;AMCV_664516D751E565010A490D4C%40AdobeOrg=MCMID|21899394311124614103351556170195253997;JVMID=mi-interceptor-app-green;MI_SITE=perf4;sessionID=592D70E4-79E9-5814-8CA7-CC7B8F284295;dtCookie=v_4_srv_4_sn_34E1C992F17597E6A4C6EAA27D8F78BE_perc_100000_ol_0_mul_1_app-3A220110cf75551a30_1_app-3Ae18958854e96e59b_1_rcs-3Acss_1;',
      'x-akamai-edgescape':
        'georegion=104,country_code=IN,region_code=MH,city=MUMBAI,lat=18.98,long=72.83,timezone=GMT+5.50,continent=AS,throughput=vhigh,bw=5000,asnum=55256,location_id=0',
      'x-client-ip': '163.116.205.113',
      'x-aka-nim-cd-fwd-origin': 'phoenix-uat05',
      'x-aka-nim_cd_fwd_origin': 'phoenix-uat05',
      'x-akamai-device-characteristics':
        'accept_third_party_cookie=true;ajax_support_javascript=true;ajax_preferred_geoloc_api=none;brand_name=Chrome;cookie_support=true;device_os=Windows NT;device_os_version=10.0;dual_orientation=false;flash_lite_version=;full_flash_support=false;gif_animated=true;html_preferred_dtd=html4;is_tablet=false;is_wireless_device=false;jpg=true;marketing_name=Chrome 144;max_image_height=600;max_image_width=800;mobile_browser=Chrome;mobile_browser_version=144;model_name=144;pdf_support=true;physical_screen_height=175;physical_screen_width=280;png=true;preferred_markup=html_web_5_0;resolution_height=800;resolution_width=1280;viewport_initial_scale=;viewport_width=width_equals_max_image_width;xhtml_file_upload=supported;xhtml_preferred_charset=utf8;xhtml_support_level=4;xhtml_supports_iframe=full;xhtml_supports_table_for_layout=false;xhtmlmp_preferred_mime_type=text/html;is_mobile=false;xhtml_table_support=true',
      'cdn-loop': 'akamai;v=1.0;c=1',
      'x-akamai-config-log-detail': 'true',
      'accept-encoding': 'gzip,br',
      'akamai-origin-hop': '2',
      via: '1.1 v1-akamaitech.net(ghost) (AkamaiGHost), 1.1 akamai.net(ghost) (AkamaiGHost)',
      'cache-control': 'no-cache, max-age=0',
      phoenix: 'true',
      hybridaemredirect: 'true',
      'x-dynatrace-application':
        'v=2;appId=ea7c4b59f27d43eb;cookieDomain=marriott.com;rid=1792702070;rpid=-505818941;en=i2tx9tp8',
      'x-dynatrace-requeststate': 'agentId=0xd8c9ff485db30342&pathDepth=1',
      'x-dynatrace':
        'FW4;786222023;4;1572012866;351488;3;-2073966679;1170;3b77;2h03;3h5236589c;4h2ab4c2;5h01;6h027b6294a298e4db20c9fbcc5c19037c;7h5c871abde20b7316',
      traceparent: '00-027b6294a298e4db20c9fbcc5c19037c-5c871abde20b7316-01',
      tracestate:
        '8461c7a9-2edccbc7@dt=fw4;4;5db30342;55d00;3;0;0;492;85c4;2h03;3h5236589c;4h2ab4c2;5h01;7h5c871abde20b7316',
      'x-ruxit-forwarded-for': '163.116.205.113, 163.116.205.113, 163.116.205.113',
      'x-host': 'www.swi-bpv.marriott.com',
      'x-schema': 'https',
    },
  },
};

export const mockPreprocessorConservation = {
  preProcessorResponse: {
    userSegment: 'NOT Logged In',
    validMarsha: true,
    status: 'SUCCESS',
    message: '',
    statusCode: '200',
    brandCode: 'RI',
    experienceSegment: 'PreConnect-Unknown-LoginConnectNow',
    locale: 'en-US',
    subDirectory: 'en',
    currentStateMapping: {
      title: 'title',
      welcomeText: '',
      description: 'unknownDescription',
      isConnectState: true,
      connectUpgradeBtn: 'connectButtonLabel',
      signInButton: {
        signInButtonLink: '',
        signInButtonLabel: '',
        signInButtonLinkInNewTab: '',
      },
      joinNowButton: {
        joinButtonLabel: '',
        joinButtonLink: '',
        joinButtonLinkInNewTab: '',
      },
      termsAndConditions: 'termsAndConditions',
      signInText: 'signInText',
      noLoginInterfaceModal: false,
      showLoginModal: true,
      loginModal: {
        default: true,
        separatorLabel: true,
        connectNowLabel: true,
      },
      showAccessModal: false,
      accessModal: {
        default: false,
        acErrorMessage: false,
      },
      showReqAccessModal: false,
      reqAccessModal: {
        default: false,
        racErrorMessage: false,
      },
      showUpgradeGenErr: false,
      showUpgradeLRErr: false,
      showUpgradeMaxErr: false,
      showUpgradeNoCCErr: false,
      showUpgradePMSErr: false,
      showUpgradeSuccessNAInfo: false,
      showUpgradeSuccessMAXInfo: false,
      showPricingModal: false,
      showUpgradeModal: false,
      showLoyaltyWelcomeModal: false,
    },
    enrollmentSourceCodeMapping: {
      nonloyalty: [],
      loyalty: [
        {
          globalDivision: ['US Canada'],
          enableSkipEnrollmentVerbiage: false,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFS8',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          brandTierCategories: [
            {
              pricingTier: [
                {
                  value: 'WFDA',
                  key: '*',
                },
              ],
              brandTier: 'select',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDB',
                  key: '*',
                },
              ],
              brandTier: 'premium',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDC',
                  key: '*',
                },
              ],
              brandTier: 'luxury',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDA',
                  key: '*',
                },
              ],
              brandTier: 'longer stays',
              experience: 'conservative-without-incentive',
            },
          ],
        },
      ],
    },
    weChatEnrollmentSourceCodes: [
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWC',
            key: '*',
          },
        ],
        region: 'Mainland China',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWH',
            key: '*',
          },
        ],
        region: 'Hong Kong',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWM',
            key: '*',
          },
        ],
        region: 'Macau',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWT',
            key: '*',
          },
        ],
        region: 'Taiwan',
      },
    ],
    appId: 'mi-aem-ppv5-spa',
    enableLoyalty: true,
    enableLoyaltyPostConnect: false,
    disableImageModifier: false,
    ageExperienceConfig: null,
    pageComponentOrder: {
      itemsOrder: [
        'staticwrapper_672883066',
        'localheader',
        'hero_banner',
        'brandedcontainer_1172064606',
        'brandedcontainer_1917356031',
        'brandedcontainer_1528490355',
        'brandedcontainer_403518150',
        'brandedcontainer_1436165928',
        'brandedcontainer_1698652079',
        'brandedcontainer_449247067',
        'brandedcontainer_391718765',
        'brandedcontainer_940818128',
        'brandedcontainer_897514845',
        'brandedcontainer',
        'brandedcontainer_7866',
        'brandedcontainer_884195529',
        'brandedcontainer_1698652066',
        'language_selector',
      ],
    },
    propertyInfo: {
      data: {
        basicInformation: {
          globalDivision: 'US Canada',
          currency: 'USD',
          region: 'US East',
        },
        contactInformation: {
          address: {
            country: {
              code: 'US',
            },
          },
        },
        internet: {
          connectionPricingDetails: [
            {
              externalRecordId: 5931023,
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier1',
              type: 'public_area_room_conn_pricing',
              feeDetails: {
                fee: null,
                feeInterval: null,
                feeType: 'C',
                settlementFee: null,
                settlementCurrency: null,
              },
            },
            {
              externalRecordId: 5909298,
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier1',
              type: 'guest_room_conn_pricing',
              feeDetails: {
                fee: 0,
                feeInterval: null,
                feeType: 'C',
                settlementFee: null,
                settlementCurrency: null,
              },
            },
            {
              externalRecordId: 6057621,
              hasOtherThanHotelQuotingCurrency: true,
              tierType: 'Tier2',
              type: 'guest_room_conn_pricing',
              feeDetails: {
                fee: 4.95,
                feeInterval: 'PD',
                feeType: 'F',
                settlementFee: 7,
                settlementCurrency: {
                  description: 'Jordanian Dinar',
                  code: 'JOD',
                },
              },
            },
          ],
        },
      },
    },
    enableLoyaltyConference: false,
    enableLoyaltyConferencePostConnect: false,
    loyaltyFlip: false,
    sameTab: false,
    cna: false,
    mac: false,
    marsha: 'MIANM',
    acceptLanguage: 'en-US,en;q=0.9',
    state: 'preconnect',
    userState: 'unknown',
    cookie: 'sessionID=592D70E4-79E9-5814-8CA7-CC7B8F284295',
    headersData: {
      host: 'phoenix-www.swi-bpv.marriott.com',
      'x-request-id': '/einterface/v5/MIANM~X~C8C16B0F-5382-5E01-9546-4A85F8B5F351',
      'x-real-ip': '163.116.205.113',
      'x-forwarded-for': '163.116.205.113',
      'x-forwarded-host': 'phoenix-www.swi-bpv.marriott.com',
      'x-forwarded-port': '443',
      'x-forwarded-proto': 'https',
      'x-forwarded-scheme': 'https',
      'x-scheme': 'https',
      'x-original-forwarded-for': '163.116.205.113',
      'accept-language': 'en-US,en;q=0.9',
      pragma: 'no-cache',
      'sec-ch-ua': '"Not(A:Brand";v="8", "Chromium";v="144", "Google Chrome";v="144"',
      'sec-ch-ua-mobile': '?0',
      'sec-ch-ua-platform': '"Windows"',
      'upgrade-insecure-requests': '1',
      'user-agent':
        'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36',
      accept:
        'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
      'sec-fetch-site': 'none',
      'sec-fetch-mode': 'navigate',
      'sec-fetch-user': '?1',
      'sec-fetch-dest': 'document',
      eks: 'true',
      priority: 'u=0, i',
      cookie:
        'device-characteristics=brand_name=Chrome&model_name=144&marketing_name=Chrome+144&device_os=Windows+NT&device_os_version=10.0&mobile_browser=Chrome&mobile_browser_version=144&is_mobile=false&is_tablet=false;OptanonConsent=isGpcEnabled=0&datestamp=Fri+Jan+30+2026+20%3A06%3A02+GMT%2B0530+(India+Standard+Time)&version=202411.2.0&browserGpcFlag=0&isIABGlobal=false&hosts=&consentId=ea338703-b880-4e69-8976-55340506687f&interactionCount=1&isAnonUser=1&landingPath=NotLandingPage&groups=1%3A1%2C3%3A1%2C4%3A1%2C6%3A1&AwaitingReconsent=false;authStateToken=;AMCV_664516D751E565010A490D4C%40AdobeOrg=MCMID|21899394311124614103351556170195253997;JVMID=mi-interceptor-app-green;MI_SITE=perf31;sessionID=592D70E4-79E9-5814-8CA7-CC7B8F284295;dtCookie=v_4_srv_4_sn_34E1C992F17597E6A4C6EAA27D8F78BE_perc_100000_ol_0_mul_1_app-3A220110cf75551a30_1_app-3Ae18958854e96e59b_1_rcs-3Acss_1;',
      'x-akamai-edgescape':
        'georegion=104,country_code=IN,region_code=MH,city=MUMBAI,lat=18.98,long=72.83,timezone=GMT+5.50,continent=AS,throughput=vhigh,bw=5000,asnum=55256,location_id=0',
      'x-client-ip': '163.116.205.113',
      'x-aka-nim-cd-fwd-origin': 'phoenix-uat05',
      'x-aka-nim_cd_fwd_origin': 'phoenix-uat05',
      'x-akamai-device-characteristics':
        'accept_third_party_cookie=true;ajax_support_javascript=true;ajax_preferred_geoloc_api=none;brand_name=Chrome;cookie_support=true;device_os=Windows NT;device_os_version=10.0;dual_orientation=false;flash_lite_version=;full_flash_support=false;gif_animated=true;html_preferred_dtd=html4;is_tablet=false;is_wireless_device=false;jpg=true;marketing_name=Chrome 144;max_image_height=600;max_image_width=800;mobile_browser=Chrome;mobile_browser_version=144;model_name=144;pdf_support=true;physical_screen_height=175;physical_screen_width=280;png=true;preferred_markup=html_web_5_0;resolution_height=800;resolution_width=1280;viewport_initial_scale=;viewport_width=width_equals_max_image_width;xhtml_file_upload=supported;xhtml_preferred_charset=utf8;xhtml_support_level=4;xhtml_supports_iframe=full;xhtml_supports_table_for_layout=false;xhtmlmp_preferred_mime_type=text/html;is_mobile=false;xhtml_table_support=true',
      'cdn-loop': 'akamai;v=1.0;c=1',
      'x-akamai-config-log-detail': 'true',
      'accept-encoding': 'gzip,br',
      'akamai-origin-hop': '2',
      via: '1.1 v1-akamaitech.net(ghost) (AkamaiGHost), 1.1 akamai.net(ghost) (AkamaiGHost)',
      'cache-control': 'no-cache, max-age=0',
      phoenix: 'true',
      hybridaemredirect: 'true',
      'x-dynatrace-application':
        'v=2;appId=ea7c4b59f27d43eb;cookieDomain=marriott.com;rid=-1459273381;rpid=1815699199;en=i2tx9tp8',
      'x-dynatrace-requeststate': 'agentId=0x3e6b6e8a8a9070d3&pathDepth=1',
      'x-dynatrace':
        'FW4;786222023;4;-1970245421;46747;3;-2073966679;497;63b5;2h03;3h5236589c;4h2aaa82;5h01;6h9d372a2d67386681149474cfefc079ea;7h8c18d54fa5774505',
      traceparent: '00-9d372a2d67386681149474cfefc079ea-8c18d54fa5774505-01',
      tracestate:
        '8461c7a9-2edccbc7@dt=fw4;4;8a9070d3;b69b;3;0;0;1f1;88b2;2h03;3h5236589c;4h2aaa82;5h01;7h8c18d54fa5774505',
      'x-ruxit-forwarded-for': '163.116.205.113, 163.116.205.113, 163.116.205.113',
      'x-host': 'www.swi-bpv.marriott.com',
      'x-schema': 'https',
    },
  },
};

export const mockPreprocessorAgeExp = {
  preProcessorResponse: {
    userSegment: 'NOT Logged In',
    validMarsha: true,
    status: 'SUCCESS',
    message: '',
    statusCode: '200',
    brandCode: 'RI',
    experienceSegment: 'Connected-Unknown-Tier1-Guest',
    locale: 'en-US',
    subDirectory: 'en',
    currentStateMapping: {
      title: 'tier1Title',
      welcomeText: 'welcomeText',
      description: 'unknownConnectedDescription',
      isConnectState: false,
      connectUpgradeBtn: 'upgradeButtonLabel',
      signInButton: {
        signInButtonLink: '',
        signInButtonLabel: '',
        signInButtonLinkInNewTab: '',
      },
      joinNowButton: {
        joinButtonLabel: 'joinButtonLabel',
        joinButtonLink: 'joinButtonLink',
        joinButtonLinkInNewTab: 'joinButtonLinkInNewTab',
      },
      termsAndConditions: 'termsAndConditions',
      signInText: '',
      noLoginInterfaceModal: false,
      showLoginModal: false,
      loginModal: {
        default: false,
        separatorLabel: false,
        userAccessCodeLabel: false,
        requestAccessCodeLabel: false,
        errorMessage: false,
        connectNowLabel: false,
      },
      showAccessModal: false,
      accessModal: {
        default: false,
        acErrorMessage: false,
      },
      showReqAccessModal: false,
      reqAccessModal: {
        default: false,
        racErrorMessage: false,
      },
      showUpgradeGenErr: false,
      showUpgradeLRErr: false,
      showUpgradeMaxErr: false,
      showUpgradeNoCCErr: false,
      showUpgradePMSErr: false,
      showUpgradeSuccessNAInfo: false,
      showUpgradeSuccessMAXInfo: false,
      showPricingModal: false,
      showUpgradeModal: false,
      showLoyaltyWelcomeModal: false,
    },
    enrollmentSourceCodeMapping: {
      nonloyalty: [],
      loyalty: [
        {
          globalDivision: ['US Canada'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: false,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFS8',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: true,
          brandTierCategories: [
            {
              pricingTier: [
                {
                  value: 'WFDA',
                  key: '*',
                },
              ],
              brandTier: 'select',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDB',
                  key: '*',
                },
              ],
              brandTier: 'premium',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDC',
                  key: '*',
                },
              ],
              brandTier: 'luxury',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDA',
                  key: '*',
                },
              ],
              brandTier: 'longer stays',
              experience: 'conservative-without-incentive',
            },
          ],
        },
        {
          globalDivision: ['EMEA'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: false,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFE4',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: true,
          enableBonvoyLookupService: false,
          brandTierCategories: [
            {
              pricingTier: [
                {
                  value: 'WFDG',
                  key: '*',
                },
              ],
              brandTier: 'select',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDH',
                  key: '*',
                },
              ],
              brandTier: 'premium',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDI',
                  key: '*',
                },
              ],
              brandTier: 'luxury',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDG',
                  key: '*',
                },
              ],
              brandTier: 'longer stays',
              experience: 'conservative-without-incentive',
            },
          ],
        },
        {
          globalDivision: ['Caribbean Latin America'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: false,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFC5',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [
            {
              pricingTier: [
                {
                  value: 'WFDD',
                  key: '*',
                },
              ],
              brandTier: 'select',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDE',
                  key: '*',
                },
              ],
              brandTier: 'premium',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDF',
                  key: '*',
                },
              ],
              brandTier: 'luxury',
              experience: 'conservative-without-incentive',
            },
            {
              pricingTier: [
                {
                  value: 'WFDD',
                  key: '*',
                },
              ],
              brandTier: 'longer stays',
              experience: 'conservative-without-incentive',
            },
          ],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFA1',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['AU'],
          pricingTier: [
            {
              value: 'WFAU',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['BD'],
          pricingTier: [
            {
              value: 'WFBD',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['BT'],
          pricingTier: [
            {
              value: 'WFBT',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['KH'],
          pricingTier: [
            {
              value: 'WFKH',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['FJ'],
          pricingTier: [
            {
              value: 'WFFJ',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['GU'],
          pricingTier: [
            {
              value: 'WFGU',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['IN'],
          pricingTier: [
            {
              value: 'WFIN',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['ID'],
          pricingTier: [
            {
              value: 'WF3D',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['JP'],
          pricingTier: [
            {
              value: 'WFJP',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['MY'],
          pricingTier: [
            {
              value: 'WFMY',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['MV'],
          pricingTier: [
            {
              value: 'WFMV',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['NP'],
          pricingTier: [
            {
              value: 'WFNP',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['NC'],
          pricingTier: [
            {
              value: 'WFNC',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['NZ'],
          pricingTier: [
            {
              value: 'WFNZ',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['PH'],
          pricingTier: [
            {
              value: 'WFPH',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['WS'],
          pricingTier: [
            {
              value: 'WFWS',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['SG'],
          pricingTier: [
            {
              value: 'WFSG',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['KR'],
          pricingTier: [
            {
              value: 'WFKR',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['LK'],
          pricingTier: [
            {
              value: 'WFLK',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['TH'],
          pricingTier: [
            {
              value: 'WFTH',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Asia Pacific Excluding China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: ['VN'],
          pricingTier: [
            {
              value: 'WFVN',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
          brandTierCategories: [],
        },
        {
          globalDivision: ['Greater China'],
          disableAuthForSFProperty: false,
          enableSkipEnrollmentVerbiage: true,
          countryCode: [],
          pricingTier: [
            {
              value: 'WFYN',
              key: '*',
            },
          ],
          enableLoyaltyForConferenceZone: false,
          enableBonvoyLookupService: false,
        },
      ],
    },
    weChatEnrollmentSourceCodes: [
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWC',
            key: '*',
          },
        ],
        region: 'Mainland China',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWH',
            key: '*',
          },
        ],
        region: 'Hong Kong',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWM',
            key: '*',
          },
        ],
        region: 'Macau',
      },
      {
        globalDivision: ['Greater China'],
        countryCode: [],
        pricingTier: [
          {
            value: 'WFWT',
            key: '*',
          },
        ],
        region: 'Taiwan',
      },
    ],
    appId: 'mi-aem-ppv5-spa',
    enableLoyalty: false,
    enableLoyaltyPostConnect: true,
    disableImageModifier: false,
    ageExperienceConfig: null,
    pageComponentOrder: {
      itemsOrder: [
        'staticwrapper_672883066',
        'localheader',
        'hero_banner',
        'brandedcontainer_1172064606',
        'brandedcontainer_1917356031',
        'brandedcontainer_1528490355',
        'brandedcontainer_403518150',
        'brandedcontainer_1436165928',
        'brandedcontainer_1698652079',
        'brandedcontainer_449247067',
        'brandedcontainer_391718765',
        'brandedcontainer_940818128',
        'brandedcontainer_897514845',
        'brandedcontainer',
        'brandedcontainer_7866',
        'brandedcontainer_884195529',
        'brandedcontainer_1698652066',
        'language_selector',
      ],
    },
    propertyInfo: {
      data: {
        basicInformation: {
          globalDivision: 'US Canada',
          currency: 'USD',
          region: 'US East',
        },
        contactInformation: {
          address: {
            country: {
              code: 'US',
            },
          },
        },
        internet: {
          connectionPricingDetails: [
            {
              externalRecordId: 5444205,
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier1',
              type: 'public_area_room_conn_pricing',
              feeDetails: {
                fee: null,
                feeInterval: null,
                feeType: 'C',
                settlementFee: null,
                settlementCurrency: null,
              },
            },
            {
              externalRecordId: 5444950,
              hasOtherThanHotelQuotingCurrency: null,
              tierType: 'Tier1',
              type: 'guest_room_conn_pricing',
              feeDetails: {
                fee: null,
                feeInterval: null,
                feeType: 'C',
                settlementFee: null,
                settlementCurrency: null,
              },
            },
            {
              externalRecordId: 5696721,
              hasOtherThanHotelQuotingCurrency: true,
              tierType: 'Tier2',
              type: 'guest_room_conn_pricing',
              feeDetails: {
                fee: 4.95,
                feeInterval: 'PD',
                feeType: 'F',
                settlementFee: 76,
                settlementCurrency: {
                  description: 'Indian Rupee',
                  code: 'INR',
                },
              },
            },
          ],
        },
      },
    },
    enableLoyaltyConference: false,
    enableLoyaltyConferencePostConnect: false,
    loyaltyFlip: false,
    cna: false,
    mac: false,
    sameTab: false,
    marsha: 'WASDK',
    acceptLanguage: 'en-US,en;q=0.9',
    state: 'connected',
    userState: 'unknown',
    cookie: 'sessionID=CE0F4996-A6E6-5B02-9303-4B79EF1F0EE2',
    headersData: {
      host: 'phoenix-www.swi-bpv.marriott.com',
      'x-request-id': '/einterface/v5/WASDK~X~336A47F5-1AB1-5076-A55B-BFA148113FE1',
      'x-real-ip': '163.116.205.119',
      'x-forwarded-for': '163.116.205.119',
      'x-forwarded-host': 'phoenix-www.swi-bpv.marriott.com',
      'x-forwarded-port': '443',
      'x-forwarded-proto': 'https',
      'x-forwarded-scheme': 'https',
      'x-scheme': 'https',
      'x-original-forwarded-for': '163.116.205.119',
      'accept-language': 'en-US,en;q=0.9',
      pragma: 'no-cache',
      'sec-ch-ua': '"Not(A:Brand";v="8", "Chromium";v="144", "Google Chrome";v="144"',
      'sec-ch-ua-mobile': '?0',
      'sec-ch-ua-platform': '"Windows"',
      'upgrade-insecure-requests': '1',
      'user-agent':
        'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36',
      accept:
        'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
      'sec-fetch-site': 'none',
      'sec-fetch-mode': 'navigate',
      'sec-fetch-user': '?1',
      'sec-fetch-dest': 'document',
      eks: 'true',
      priority: 'u=0, i',
      cookie:
        'device-characteristics=brand_name=Chrome&model_name=144&marketing_name=Chrome+144&device_os=Windows+NT&device_os_version=10.0&mobile_browser=Chrome&mobile_browser_version=144&is_mobile=false&is_tablet=false;OptanonConsent=isGpcEnabled=0&datestamp=Thu+Feb+12+2026+16%3A28%3A13+GMT%2B0530+(India+Standard+Time)&version=202411.2.0&browserGpcFlag=0&isIABGlobal=false&hosts=&consentId=dfbed8be-ad87-4c1f-be4b-a0d7f3e81d52&interactionCount=1&isAnonUser=1&landingPath=NotLandingPage&groups=1%3A1%2C3%3A1%2C4%3A1%2C6%3A1&AwaitingReconsent=false;mbox=session#2b5419a5e1874fcf810673455ec2499e#1770892380|PC#2b5419a5e1874fcf810673455ec2499e.41_0#1834135320;dtm_token=AQAKVR0-TGWB1gEYUeijAQEL_wABAQCdUeZEmwEBAJ1R5kSb;authStateToken=;AMCV_664516D751E565010A490D4C%40AdobeOrg=-1124106680%7CMCMID%7C28957298646594547390345415328838796915%7CMCAAMLH-1771495318%7C12%7CMCAAMB-1771495318%7Cj8Odv6LonN4r3an7LhD3WZrU1bUpAkFkkiY1ncBR96t2PTI%7CMCOPTOUT-1770897718s%7CNONE%7CvVersion%7C5.2.0;JVMID=mi-interceptor-app-green;MI_SITE=perf31;sessionID=CE0F4996-A6E6-5B02-9303-4B79EF1F0EE2;',
      'x-akamai-edgescape':
        'georegion=104,country_code=IN,region_code=MH,city=MUMBAI,lat=18.98,long=72.83,timezone=GMT+5.50,continent=AS,throughput=vhigh,bw=5000,asnum=55256,location_id=0',
      'x-client-ip': '163.116.205.119',
      'x-bm-ha': '1~31~698db24d~ca4eca68136b4ae0222fa4e40cda67002ff8a6b7de6ff30aa8c799b03ec9040e',
      'x-aka-nim-cd-fwd-origin': 'phoenix-uat05',
      'x-aka-nim_cd_fwd_origin': 'phoenix-uat05',
      'x-akamai-device-characteristics':
        'accept_third_party_cookie=true;ajax_support_javascript=true;ajax_preferred_geoloc_api=none;brand_name=Chrome;cookie_support=true;device_os=Windows NT;device_os_version=10.0;dual_orientation=false;flash_lite_version=;full_flash_support=false;gif_animated=true;html_preferred_dtd=html4;is_tablet=false;is_wireless_device=false;jpg=true;marketing_name=Chrome 144;max_image_height=600;max_image_width=800;mobile_browser=Chrome;mobile_browser_version=144;model_name=144;pdf_support=true;physical_screen_height=175;physical_screen_width=280;png=true;preferred_markup=html_web_5_0;resolution_height=800;resolution_width=1280;viewport_initial_scale=;viewport_width=width_equals_max_image_width;xhtml_file_upload=supported;xhtml_preferred_charset=utf8;xhtml_support_level=4;xhtml_supports_iframe=full;xhtml_supports_table_for_layout=false;xhtmlmp_preferred_mime_type=text/html;is_mobile=false;xhtml_table_support=true',
      'cdn-loop': 'akamai;v=1.0;c=1',
      'x-akamai-config-log-detail': 'true',
      'accept-encoding': 'gzip,br',
      'akamai-origin-hop': '2',
      via: '1.1 v1-akamaitech.net(ghost) (AkamaiGHost), 1.1 akamai.net(ghost) (AkamaiGHost)',
      'cache-control': 'no-cache, max-age=0',
      phoenix: 'true',
      hybridaemredirect: 'true',
      'x-dynatrace-application':
        'v=2;appId=ea7c4b59f27d43eb;cookieDomain=marriott.com;rid=-739957124;rpid=1042266711;en=i2tx9tp8',
      'x-dynatrace-requeststate': 'agentId=0xf69ff94271debdd4&pathDepth=1',
      'x-dynatrace':
        'FW4;786222023;1;1910422996;9986232;3;-2073966679;463;3612;2h03;3h54efb96e;4h238388;5h01;6h67c9c22d9302625d871d32fb90504743;7hb92e4cd2a9066075',
      traceparent: '00-67c9c22d9302625d871d32fb90504743-b92e4cd2a9066075-01',
      tracestate:
        '8461c7a9-2edccbc7@dt=fw4;1;71debdd4;9860b8;3;0;0;1cf;395f;2h03;3h54efb96e;4h238388;5h01;7hb92e4cd2a9066075',
      'x-ruxit-forwarded-for': '163.116.205.119, 163.116.205.119, 163.116.205.119',
      'x-host': 'www.swi-bpv.marriott.com',
      'x-schema': 'https',
    },
  },
};
